// interface UserAttributes: {
//      [key: string]: {
//       string }
// }

import { Gender } from "../../enum/gender.enum";
import { Locale } from "../../enum/locale.enum";

interface JWT {
    exp: number;
    iat: number;
    iss: string;
    sub: string;
}
export enum DiscoveryStatusEnum {
    DIDNT_START = 0,
    DONE = 1,
    IN_PROGRESS = 2
}

export enum DiscoveryTypeEnum {
    Chat = 1,
    Wizard = 2
}

export enum UserRole {
    NONE = 0,
    EMPLOYEE = 1,
    MANAGER = 2,
    HR = 3
}

export enum ClaroRoles {
    REGULAR = 100,
    POWER_USER = 200,
    ADMINISTRATOR = 1000
}

export enum AccountTypeEnum {
    UNKNOWN = 0,
    REGULAR = 1,
    TRIAL = 2,
    CLARO_DISCOVERY = 3,
    CLARO_RECHARGE = 4,
    THRIVE = 5,
    COLLAB = 6,
    EXCEL = 7,
    CAREER_INDEPENDENT = 8,
    CAREER_INDEPENDENT_US = 9
}

export enum CareerProcessTypeEnum {
    NONE = 0,
    INDEVIDUAL_CONSULTANT_LEAD = 1,
    INTERNAL_ORGANIZATION_LEAD = 2
}

export enum Auth0OrighinEnum{
    MICROSOFT = 0,
    GOOGLE = 1
}

export const AccountTypeDescriptions: { [key in AccountTypeEnum]: string } = {
    [AccountTypeEnum.UNKNOWN]: 'Unknown',
    [AccountTypeEnum.REGULAR]: 'Regular',
    [AccountTypeEnum.TRIAL]: 'Trial',
    [AccountTypeEnum.CLARO_DISCOVERY]: 'Claro Discovery',
    [AccountTypeEnum.CLARO_RECHARGE]: 'Recharge',
    [AccountTypeEnum.THRIVE]: 'Thrive',
    [AccountTypeEnum.COLLAB]: 'Collab',
    [AccountTypeEnum.EXCEL]: 'Excel',
    [AccountTypeEnum.CAREER_INDEPENDENT]: 'Claro Career',
    [AccountTypeEnum.CAREER_INDEPENDENT_US]: 'Claro Career US'
  };

export function getAccountTypeDescription(type: AccountTypeEnum): string {
    return AccountTypeDescriptions[type];
  }

export enum EngagementLevelEnum {
    NONE = 0,
    FULL = 1,
    WEEKLY = 2
}

export enum ResellerTypeEnum{
    MASTER_RESELLER = 0,
    BASIC_RESELLER = 1
}

export enum PreferredEngagementCahnnelEnum{
    MAIL = 1,
    WHATSAPP = 2
}

export interface UserMinimalData {
    id: string;
    firstName: string;
    lastName: string;
    discoveryStatus: DiscoveryStatusEnum;
    orgId: string;
    gender: Gender;
    color: string;
    image?: any;
    parentId: string;
    activeMoovsCount: number;
    recommendedMoovsCount: number;
    careerProcessType : CareerProcessTypeEnum;
    currTotalEnergy: number;
    motivations: string[];
    motivationsGap: {
        [key:string]:number
    }
}

export interface UserMicroData {
    id : string;
    firstName: string;
    lastName: string;
}

export interface UserMicroData_PulseDataExtended extends UserMicroData {
    orgId: string;
    gender: Gender;
    locale: Locale;
    role: UserRole;
}

export interface UserMicroData_CircleDataExtended extends UserMicroData {
    existsInUserCircle : boolean;
}

export interface PersonalUserData  {
    id: string;
    firstName: string;
    lastName: string;
    discoveryStatus: DiscoveryStatusEnum;
    discoveryType: DiscoveryTypeEnum;
    orgId: string;
    mailAddress: string;
    phoneNumber: string;
    phoneNumberCountryCode: string;
    isPhoneNumberVerified: boolean;
    accountType: AccountTypeEnum;
    careerProcessType: CareerProcessTypeEnum;
    createdTime?: string;
    locale: Locale;
    role: number;
    claroRole: number;
    gender: Gender;
    color: string;
    image?: any;
    parentId: string;
    activeMoovsCount: number;
    recommendedMoovsCount: number;
    presentFullHierarchy?: boolean;
    allowShareMotivations: boolean;
    allowShareCalendar: boolean;
    isReseller: boolean;
    currTotalEnergy: number;
    motivations: string[];
    motivationsGap: {
        [key:string]:number
    }
    // motivations: string[];
    personsOfInterest?: string[];
    isRTL?: boolean;
    engagementLevel?: number;
    shouldGetQuestioners: boolean;
    preferredEngagementCahnnel : PreferredEngagementCahnnelEnum;
}

export interface RegisteredUserData {
    firstName: string;
    lastName: string;
    mailAddress: string;
    locale: Locale;
    gender: Gender;
    inMgmtPos: boolean;
}

export interface PersonalUserDataWithToken extends JWT, PersonalUserData {

}
export interface CoiData {
    teamMembersList: UserMinimalData[];
    peopleOfInterest: UserMinimalData[];
}

export interface SkipRelationshipQuestionsData{
    userId: string;
    counterpartId: string;
    timestamp: Date;
}

export interface UserAlert{
    id: string;
    userId: string;
    type: number;
    text: string;
    extendedText: string;
    actionUrl: string;
}

export interface ResellerData{
    id : string
    firstName : string
    lastName : string
    mailAddress : string
    userId : string
    resellerType : ResellerTypeEnum
    createdTimeStamp : Date
    description : string
}

export interface ResellerTokesStatusData_String{
    totalActiveTokens : {[key:string] : number}
    freeTokens : {[key:string] : number}
    allocatedTokens: {[key:string] : number}
}


export interface ResellerTokesStatusData{
    totalActiveTokens :{[key:number] : number}
    freeTokens : {[key:number] : number}
    allocatedTokens: {[key:number] : number}
}

export interface DateData{
    date : Date;
}

export interface UserCreatedOrgData{
    id: string
    name: string
    description: string
    ownerId: string
    createdTimeStamp : Date
    allocatedTokens : number
}

export interface AccessTokenData{
    id : string
    tokenBody : string
    ownerId : string
    activeResellerId : string
    state : number
    createdTimeStamp : Date
    activationTimeStamp : Date
    allocationTimeStamp : Date
    orgId : string
    parentId : string
    accountType : AccountTypeEnum
}

export interface UserAuth0RedactedData{
    id: string;
    upn: string;
    origin: number
    timestamp: Date;
}

export interface OrgDataUpdateReport{
    content: string;
}

export interface OrgDataUpdateFieldChange {
    before: any;
    expected: any;
    actual?: any;
    verified?: boolean;
}

export interface OrgDataUpdateChange {
    type: 'user_updated' | 'user_deactivated' | 'new_user';
    userId?: string;
    email: string;
    supervisorEmail?: string;
    fields?: {[fieldName: string]: OrgDataUpdateFieldChange};
    sourceRecord?: {[fieldName: string]: string};
    verification: {status: 'pending' | 'passed' | 'failed' | 'not_applicable'; error?: string};
}

export interface OrgDataUpdateSummary {
    totalUsersReceived: number;
    totalUntouchedUsers: number;
    totalUpdatedUsers: number;
    totalOptedOutUsers: number;
    totalDeactivatedUsers: number;
    totalIgnoredUsers: number;
    totalInactiveOptedOut: number;
    verificationPassed: number;
    verificationFailed: number;
    verificationNotApplicable: number;
}

export interface OrgDataUpdateRun {
    schemaVersion?: number;
    runId: string;
    orgId: string;
    orgName: string;
    status: 'legacy' | 'preview' | 'applying' | 'applied' | 'applied_with_errors';
    createdAt: string;
    startedAt?: string;
    finishedAt?: string;
    previousRunId?: string;
    planHash?: string;
    source: {bucket: string; object: string; sha256: string; generation?: string; etag?: string; retrievedAt: string};
    summary: OrgDataUpdateSummary;
    changes?: OrgDataUpdateChange[];
    newUsers?: Array<{[fieldName: string]: string}>;
}

export interface OrgDataUpdateComparison {
    orgId: string;
    fromRunId: string;
    toRunId: string;
    summaryDelta: {[summaryName: string]: number};
    newChanges: OrgDataUpdateChange[];
    resolvedChanges: OrgDataUpdateChange[];
    persistentChanges: OrgDataUpdateChange[];
}

export interface UserCVMetadata{
    id: string;
    fileName: string;
    uploadTimestamp?: Date;
    analysisTimestamp?: Date;
    isAnalyzed: boolean;
}
